import { useState } from 'react';

import { Input } from '@saas-kit/ui';

/**
 * Inline rank editor for a customer type. A lower rank is served first, so
 * this is how an operator promotes a tier to priority after it was created.
 * Commits on blur or Enter; reverts when the value is blank or unchanged.
 */
export function CustomerTypeRankCell({
  rank,
  canManage,
  onCommit,
}: {
  rank: number;
  canManage: boolean;
  onCommit: (rank: number) => void;
}): JSX.Element {
  const [value, setValue] = useState(String(rank));

  if (!canManage) return <span>{rank}</span>;

  const commit = (): void => {
    const next = Number(value);
    if (!Number.isInteger(next) || next < 0 || next === rank) {
      setValue(String(rank));
      return;
    }
    onCommit(next);
  };

  return (
    <Input
      type="number"
      min={0}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.currentTarget.blur();
      }}
      className="ms-auto h-8 w-20 text-end"
    />
  );
}
